import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { DeleteIcon } from '@/shared/components/Icons';
import { CanUpdate } from '@/shared/components/security';
import api from '@/shared/api';
import config from '@/config';
import UserSearch from '@/shared/components/input/UserSearch';
import DataCacheService from '@/shared/services/DataCacheService';
import HandleHttpError from '@/shared/services/HandleHttpError';
import OkModal from '@/shared/components/OkModal';
import Button from '@/shared/components/Button';
import classNames from 'classnames';

const messages = defineMessages({
  SelectDocumentTypeToAdd: 'Select type to add',
  AllowedUsers: 'Allowed users',
  AddUser: 'Add user',
  Close: 'Close',
  Save: 'Save',
});

class EditDocumentTagUserAccessDialog extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      userAccesses: [],
      newUser: undefined,
    };
  }

  getUserAccess = async () => {
    const { tagId } = this.props;
    const response = await api.base.get(`${config.appUrls.documents}/api/tag/${tagId}/access`);
    return response.data;
  };

  componentDidMount() {
    const { intl } = this.props;

    this.getUserAccess(intl).then(userAccesses => {
      this.setState({ userAccesses });
    });
  }

  removeUserAccess = id => {
    const { tagId, intl } = this.props;
    const { userAccesses } = this.state;
    return api.base.delete(`${config.appUrls.documents}/api/tag/${tagId}/access/${id}`).then(
      () => {
        this.setState({ userAccesses: userAccesses.filter(x => x.id !== id) });
      },
      error => HandleHttpError(intl)(error),
    );
  };

  save = () => {
    const { newUser, userAccesses } = this.state;
    const { tagId, intl } = this.props;
    if (!newUser) return;

    return api.base.post(`${config.appUrls.documents}/api/tag/${tagId}/access/${newUser.id}`).then(
      ({ data }) => {
        this.setState({ newUser: undefined, userAccesses: [...userAccesses, data] });
      },
      error => HandleHttpError(intl)(error),
    );
  };

  render() {
    const { userAccesses, newUser } = this.state;
    const { onClose, intl } = this.props;

    const enrichedUserAccesses = userAccesses?.map(x => {
      return {
        ...x,
        user: DataCacheService.getUser(x.userId),
      };
    });

    return (
      <OkModal
        show
        title={intl.formatMessage(messages.AllowedUsers)}
        okClassName="btn btn-default"
        onClose={() => onClose(userAccesses)}
        onSave={() => this.save()}
        okLabel={intl.formatMessage(messages.Close)}
      >
        <form>
          <div className="form-horizontal">
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <UserSearch
                  onChange={user => this.setState({ newUser: user })}
                  placeholder={intl.formatMessage(messages.AddUser)}
                  value={newUser?.id}
                />
              </div>
              <CanUpdate on="CompanyOwn">
                <Button
                  onClick={this.save}
                  disabled={!newUser}
                  btnClassName="btn-inverse"
                  showProgress
                >
                  {intl.formatMessage(messages.Save)}
                </Button>
              </CanUpdate>
            </div>

            <div className="form-group">
              <div className="col-md-12">
                {enrichedUserAccesses?.length > 0
                  ? enrichedUserAccesses.map(x => (
                      <div key={x.id} className="pad5">
                        <span className={classNames('margin5R', { red: !x.user.isActive })}>
                          {DataCacheService.getUserName(x.userId)}
                        </span>
                        <DeleteIcon onClick={() => this.removeUserAccess(x.id)} />
                      </div>
                    ))
                  : null}
              </div>
            </div>
          </div>
        </form>
      </OkModal>
    );
  }
}

EditDocumentTagUserAccessDialog.propTypes = {
  tagId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(EditDocumentTagUserAccessDialog);
